import React, { useEffect } from "react";
import {
    Box,
    Button,
    TextField,
    Typography,
    Grid,
    Paper,
    MenuItem,
    Snackbar,
    Alert,
} from "@mui/material";
import axios from "axios";
import { useSelector } from "react-redux";
import { AttachFile } from "@mui/icons-material";
import RefreshIcon from '@mui/icons-material/Refresh';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import withLanguage from "../../HOC/withLanguage";
import withAuthChecker from "../../HOC/withAuthChecker";
import CustomTable from "./ArsimiDualComponents/CustomTable";
import {formatToDateInput, isAtLeastYears} from "./../Shared/helperFunctions"

let pageSize = 5;

/* ---------- component ---------- */
const StudentApplication = ({ language }) => {
    const user = useSelector(state => state.user);
    const [submitting, setSubmitting] = React.useState(false);
    const [schoolOptions, setSchoolOptions] = React.useState([]);
    const [qualificationOptions, setQualificationOptions] = React.useState([]);
    const [businessOptions, setBusinessOptions] = React.useState([]);
    const [readOnlyForm, setReadOnlyForm] = React.useState(false);
    const [schoolYears, setSchoolYears] = React.useState([]);
    const [applications, setApplications] = React.useState(null);
    const [snackbar, setSnackbar] = React.useState({ open: false, message: "", severity: "success" });
    const closeSnackbar = () => setSnackbar((s) => ({ ...s, open: false }));
    const [showForm, setShowForm] = React.useState(false);
    const [accessMessage, setAccessMessage] = React.useState("");
    const [page, setPage] = React.useState(0);

    const [errors, setErrors] = React.useState({
      birthdate: "",
    });

    const [touched, setTouched] = React.useState({
      birthdate: false,
      document: false,
    });

    const defaultSa = () => ({
        nid: "",
        fullName: "",
        birthdate: "",
        phone: "",
        email: "",
        whoAmI: "",
        institutionId: "",
        qualificationId: "",
        schoolYearId: "",
        practiceEmployerId: "",
        documentName: "",
        documentBase64: "",
        vlp:"",
    });

    const columns = [
      {
        header: language?.sa_institutionName,
        accessor: "educational_institution_name",
        cellClassName:
          "border-b border-slate-100 px-4 py-4 text-sm font-medium text-slate-800",
      },
      {
        header: language?.sa_qualificationName,
        accessor: "dual_qualification_name",
        cellClassName:
          "border-b border-slate-100 px-4 py-4 text-sm text-slate-700",
      },
      {
        header: language?.sa_employer,
        accessor: "business_name",
        cellClassName:
          "border-b border-slate-100 px-4 py-4 text-sm text-slate-700",
      },
      {
        header: language?.sa_dateApplied,
        accessor: "date_applied",
        isDate: true,
        cellClassName:
          "border-b border-slate-100 px-4 py-4 text-sm text-slate-700",
      },
      {
        header: "",
        headerClassName: "text-right",
        cellClassName: "border-b border-slate-100 px-4 py-4 text-right",
        render: (item) => (
          <button
            className="inline-flex border-0 bg-transparent text-[#dc2626]"
            onClick={() => showApplicationDetails(item)}
          >
            <ArrowForwardIcon />
          </button>
        ),
      },
    ];

    const [sa, setSa] = React.useState(defaultSa());

    const saOnChange = (e) => {
        const { name, value } = e.target;
        setSa((s) => ({ ...s, [name]: value }));

        if (name === "birthdate") {
          if (!isAtLeastYears(value, 15)) {
            setErrors((prev) => ({
              ...prev,
              birthdate: language.birthdate,
            }));
          } else {
            setErrors((prev) => ({
              ...prev,
              birthdate: "",
            }));
          }
        }
    };

    const handleBlur = (e) => {
      const { name } = e.target;

      setTouched((prev) => ({
        ...prev,
        [name]: true,
      }));
    };

    const getDocumentError = () => {
      if (!touched.document) return "";
      if (!sa.documentBase64) return language.fileRequired;
      return "";
    };
    

    const onChangeSelectSa = (name, value) => {
        setSa((s) => {
            if (name === "institutionId") {
            if (s.institutionId === value) return s;

            return {
                ...s,
                institutionId: value,
                qualificationId: "",
            };
            }

            return { ...s, [name]: value };
        });
    };

    const getApplicationsData = () => {
      if(!user?.nid) return
      axios.get(`/api/nid_job_applications/${user?.nid}?page=${page+1}&per_page=${pageSize}`, {
          headers: { "API_KEY": "123456789" },
      })
      .then((res) => {
          if(res?.status === 200) {
              setApplications(res?.data)
          } 
      })
      .catch((err) => {
        setApplications(null)
      });
    }

    useEffect(() => {
        getApplicationsData()
    }, [user, page, pageSize])

    const onSubmit = (e) => {
        e.preventDefault();
        setSubmitting(true)
        setTouched((prev) => ({
          ...prev,
          birthdate: true,
          document: true,
        }));

        if (!sa.documentBase64) {
          setSnackbar({
            open: true,
            message: language.fileRequired,
            severity: "error",
          });
          setSubmitting(false)
          return;
        }

        const payload = {
            nid: sa.nid || "",
            full_name: sa.fullName || "",
            birth_date: sa.birthdate || "",
            phone: sa.phone || "",
            email: sa.email || "",
            who_am_i: sa.whoAmI || "",
            dual_qualification_id: sa.qualificationId || "",
            school_year_id: sa.schoolYearId || "",
            business_id: sa.practiceEmployerId || "",
            educational_institution_id: sa.institutionId || "",
            document_filename: sa.documentName || "",
            document: sa.documentBase64 || "",
            vlp: sa.vlp || ""
        };


        if(!payload?.nid || !payload?.full_name || !payload?.birth_date || !payload?.dual_qualification_id || !payload?.school_year_id || !payload?.business_id || !payload?.educational_institution_id || !payload?.document) {
            setSnackbar({ open: true, message: language.loginAndFieldsRequired, severity: "error" });
            setSubmitting(false)
            return
        }

        axios.post("/api/job_application", JSON.stringify(payload), {
            headers: { "API_KEY": "123456789", "Content-Type": "text/plain" },
        })
          .then((res) => {
              setTouched({
                birthdate: false,
                document: false,
              });
              setSnackbar({ open: true, message: language.submitSuccess, severity: "success" });
              setSa(defaultSa());
              setSubmitting(false)
          })
          .catch((err) => {
            const message =
                  err.response?.data?.message || 
                  language?.requestFailed
              setSnackbar({ open: true, message: message, severity: "error" });
              setSubmitting(false)
          });
    };

    React.useEffect(() => {
      if(!showForm) return

      axios.get("/api/data/institution?dual_education__exact=true", {
          headers: { API_KEY: "123456789" },
      })
      .then((res) => {
          const data = res.data;
          if (Array.isArray(data)) {
              setSchoolOptions(data);
          } else {
              setSchoolOptions([]);
          }
      })
      .catch(() => {
          setSchoolOptions([]);
      });

      axios.get(`/api/data/school_year?is_active__exact=true`, { 
          headers: { API_KEY: "123456789" },
      })
      .then((res) => {
          const data = res.data;
          setSchoolYears(data);
          
      })
      .catch(() => {
          setSchoolYears([]);
      });
    }, [showForm]);

    useEffect(() => {
      if(!showForm || !user) return
        if (user) {
            setSa((s) => ({
                ...s,
                nid: user?.nid || "",
                fullName: user?.name || "",
                phone: user?.mobile || "",
                email: user?.email || "",
            }));
        }
    }, [user, showForm]);


    useEffect(() => {
        if(!showForm || !sa.institutionId) return
        axios.get(`/api/institution_configuration/degree?institution_id__exact=${sa.institutionId}&dual_education__exact=true`, { 
            headers: { API_KEY: "123456789" },
        })
            .then((res) => {
                const data = res.data;
                if (Array.isArray(data)) {
                    setQualificationOptions(data);
                } else {
                    setQualificationOptions([]);
                }
            })
            .catch(() => {
                setQualificationOptions([]);
            });
    }, [showForm, sa.institutionId])

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    useEffect(() => {
      
      if(!showForm || !sa.institutionId || !sa.qualificationId || !sa.schoolYearId) return
      axios.get(`/api/get_approved_businesses/${sa.institutionId}/${sa.qualificationId}/${sa.schoolYearId}`, {
          headers: { API_KEY: "123456789" },
      })
      .then((res) => {
          const data = res.data; 
          setBusinessOptions(data); 
      })
      .catch(() => {
          setBusinessOptions([]);
      });
    }, [showForm, sa.institutionId, sa.qualificationId, sa.schoolYearId]);

    const showApplicationDetails = (application) => {
        setReadOnlyForm(true);
        setShowForm(true);

        setSa((s) => ({
          nid: application?.nid || "",
          fullName: application?.full_name || "",
          phone: application?.phone || "",
          email: application?.email || "",
          birthdate: formatToDateInput(application?.birth_date) || "",
          whoAmI: application?.who_am_i || "",
          institutionId: application?.educational_institution_id || "",
          qualificationId: application?.dual_qualification_id || "",
          schoolYearId: application?.school_year_id || "",
          practiceEmployerId: application?.business_id || "",
          documentName: application?.document_filename || "",
          documentBase64: application?.document || "",
          vlp:Number(application?.vlp) || "",
        }));
    };

    const handleApply = () => {
      if(!user){
        setAccessMessage(language?.sa_individualRequired);
        setShowForm(false);
      } else if (user?.type?.toLowerCase() === "organisation") {
        setAccessMessage(language?.sa_businessNotAllowed);
        setShowForm(false);
      } else {
        setReadOnlyForm(false);
        setSa((s) => ({
          nid: user?.nid || "",
          fullName: user?.name || "",
          phone: user?.mobile || "",
          email: user?.email || "",
          birthdate: "",
          whoAmI: "",
          institutionId: "",
          qualificationId: "",
          schoolYearId: "",
          practiceEmployerId: "",
          documentName: "",
          documentBase64: "",
          vlp:"",
        }));
        setAccessMessage("");
        setShowForm(true);
      }
  
    }

    return (
      <section className="flex flex-1 items-center">
        <Box
          component="form"
          onSubmit={onSubmit}
          sx={{ display: "grid", gap: 2, width: '100%', }}
        >
         <Paper elevation={0} sx={{ width: "100%" }}>
            {!showForm ? (
              <Grid
                sx={{
                  position: "relative",
                  justifyContent: "center",
                  alignItems: "center",
                  textAlign: "center",
                  width: '100%',
                  py: 6,
                }}
              >
                {  applications?.records?.length > 0 && (
                  <>
                    <button
                      type="button"
                      className="inline-flex border-0 bg-transparent text-[#dc2626] absolute top-20 right-9"
                      onClick={() => {
                        setPage(0);
                        getApplicationsData();
                      }}
                    >
                      <RefreshIcon />
                    </button>
                    <CustomTable
                      title={`${language?.sa_applications}:`}
                      data={applications?.records || []}
                      columns={columns}
                      pagination={{
                        count: applications?.amount,
                        pageSize,
                        page,
                        onPageChange: handleChangePage,
                      }}
                    />
                  </>
                )}
                <Grid item xs={12}>
                  <Typography
                    variant="h6"
                    sx={{ mb: 2, fontWeight: 700, fontSize: "1.8rem" }}
                  >
                    {language?.sa_middleSubtitle}
                  </Typography>
                </Grid>
                <Grid item xs={12}>
                  <Button
                    variant="outlined"
                    sx={{
                      textTransform: "none",
                      borderRadius: "1.5rem",
                      border:0,
                      padding: "0.4rem 1rem",
                      color: "#fff",
                      fontWeight: "bold",
                      backgroundColor: "#dc2626",
                      fontSize: "1rem",
                      "&:hover": {
                        border:0,
                        backgroundColor: "#dc2626",
                      },
                    }}
                    onClick={() => handleApply()}
                  >
                    {language?.sa_openButtonText}
                  </Button>
                </Grid>
                {accessMessage && (
                  <Grid item xs={12}>
                    <Typography
                      sx={{
                        display: "inline-block",
                        color: "#dc2626",
                        fontWeight: 600,
                        backgroundColor: "#fee2e2",
                        padding: "0.5rem 1rem",
                        borderRadius: "0.75rem",
                        border: "1px solid #fecaca",
                        fontSize: "0.95rem",
                        mt: 3.5,
                      }}
                    >
                      {accessMessage}
                    </Typography>
                  </Grid>
                )}
              </Grid>
            ) : (
              <>
              <Button
                  type="button"
                  variant="outlined"
                  sx={{
                    textTransform: "none",
                    marginBottom: "2rem",
                    fontWeight: "bold",
                    borderColor: "transparent",
                    color: "#dc2626",
                    backgroundColor: "transparent",
                    fontSize: "1rem",
                    "&:hover": {
                      backgroundColor: "transparent",
                      borderColor: "transparent",
                    },
                  }}
                  onClick={() => {
                    getApplicationsData()
                    setShowForm(false)
                  }}
                >
                  <ArrowBackIcon className="mr-5" />
                  {language?.backToApplicationsList}
                </Button>
                <Typography variant="subtitle1" sx={{ fontWeight: 700, mb: 1 }}>
                  {language.sa_title}
                </Typography>

                <Typography variant="subtitle2" sx={{ fontWeight: 600, mb: 1 }}>
                  {language.sa_sectionA}
                </Typography>

                <Grid container spacing={2}>
                  {/* NID */}
                  <Grid item xs={12} md={6}>
                    <TextField
                      sx={{
                        "& .MuiOutlinedInput-root": { borderRadius: "15px" },
                      }}
                      label={language.sa_nid}
                      name="nid"
                      value={sa.nid}
                      onChange={saOnChange}
                      fullWidth
                      required
                      disabled
                    />
                  </Grid>

                  {/* Full name */}
                  <Grid item xs={12} md={6}>
                    <TextField
                      sx={{
                        "& .MuiOutlinedInput-root": { borderRadius: "15px" },
                      }}
                      label={language.sa_fullName}
                      name="fullName"
                      value={sa.fullName}
                      onChange={saOnChange}
                      fullWidth
                      required
                      disabled
                    />
                  </Grid>

                  {/* Birthdate */}
                  <Grid item xs={12} md={6}>
                    <TextField
                      sx={{
                        "& .MuiOutlinedInput-root": { borderRadius: "15px" },
                      }}
                      type="date"
                      label={language.sa_birthdate}
                      name="birthdate"
                      value={sa.birthdate}
                      onChange={saOnChange}
                      onBlur={handleBlur}
                      fullWidth
                      InputLabelProps={{ shrink: true }}
                      required
                      disabled={readOnlyForm}
                      error={touched.birthdate && !!errors.birthdate}
                      helperText={touched.birthdate ? errors.birthdate : ""}
                    />
                  </Grid>

                  {/* Phone */}
                  <Grid item xs={12} md={6}>
                    <TextField
                      sx={{
                        "& .MuiOutlinedInput-root": { borderRadius: "15px" },
                      }}
                      label={language.sa_phone}
                      name="phone"
                      type="number"
                      value={sa.phone}
                      onChange={saOnChange}
                      fullWidth
                      disabled
                    />
                  </Grid>

                  {/* Email */}
                  <Grid item xs={12} md={6}>
                    <TextField
                      sx={{
                        "& .MuiOutlinedInput-root": { borderRadius: "15px" },
                      }}
                      type="email"
                      label={language.sa_email}
                      name="email"
                      value={sa.email}
                      onChange={saOnChange}
                      fullWidth
                      disabled
                    />
                  </Grid>

                  {/* Institution */}
                  <Grid item xs={12} md={6}>
                    <TextField
                      sx={{
                        "& .MuiOutlinedInput-root": { borderRadius: "15px" },
                      }}
                      select
                      label={language.sa_school}
                      value={sa.institutionId}
                      name="institutionId"
                      onChange={(e) =>
                        onChangeSelectSa("institutionId", e.target.value)
                      }
                      fullWidth
                      required
                      disabled={readOnlyForm}
                    >
                      {schoolOptions.map((s) => (
                        <MenuItem
                          key={s.id ?? s.ID ?? s.value}
                          value={s.id ?? s.ID ?? s.value}
                        >
                          {s.name}
                        </MenuItem>
                      ))}
                    </TextField>
                  </Grid>

                  {/* Qualification */}
                  <Grid item xs={12} md={6}>
                    <TextField
                      sx={{
                        "& .MuiOutlinedInput-root": { borderRadius: "15px" },
                      }}
                      select
                      name="qualificationId"
                      label={language.sa_qualification}
                      value={sa.qualificationId}
                      onChange={(e) =>
                        onChangeSelectSa("qualificationId", e.target.value)
                      }
                      fullWidth
                      required
                      disabled={!sa.institutionId || readOnlyForm}
                      
                    >
                      {qualificationOptions?.map((q) => (
                        <MenuItem
                          key={q.id}
                          value={q.id}
                        >
                          {q.name}
                        </MenuItem>
                      ))}
                    </TextField>
                  </Grid>

                  <Grid item xs={12} md={6}>
                    <TextField
                      sx={{
                        "& .MuiOutlinedInput-root": {
                          borderRadius: "15px",
                        },
                      }}
                      select
                      name="schoolYearId"
                      label={language.sd_schoolYear}
                      value={sa.schoolYearId}
                      onChange={saOnChange}
                      fullWidth
                      required
                      disabled={!sa.institutionId || !sa.qualificationId || readOnlyForm}
                    >
                      {schoolYears.map((year) => (
                        <MenuItem
                          key={year.id}
                          value={year.id}
                        >
                          {year.name}
                        </MenuItem>
                      ))}
                    </TextField>
                  </Grid>

                  {/* Practice employer / business */}
                  <Grid item xs={12} md={6}>
                    <TextField
                      sx={{
                        "& .MuiOutlinedInput-root": { borderRadius: "15px" },
                      }}
                      select
                      name="practiceEmployerId"
                      label={language.sa_practiceEmployer}
                      value={sa.practiceEmployerId}
                      onChange={(e) =>
                        onChangeSelectSa("practiceEmployerId", e.target.value)
                      }
                      fullWidth
                      required
                      disabled={!sa.institutionId || !sa.qualificationId || !sa.schoolYearId || readOnlyForm}
                    >
                      {businessOptions.length>0 ? businessOptions.map((business) => (
                        <MenuItem
                          key={business.id }
                          value={business.id}
                        >
                          {business.name}
                        </MenuItem>
                      )): <MenuItem
                          value=""
                        >
                          {language.sa_noData}
                        </MenuItem>}
                    </TextField>
                  </Grid>

                  <Grid item xs={12} md={6}>
                    <TextField
                      sx={{
                        "& .MuiOutlinedInput-root": { borderRadius: "15px" },
                      }}
                      label={language.sa_jobVacancy}
                      name="vlp"
                      value={sa.vlp}
                      onChange={saOnChange}
                      fullWidth
                      disabled={readOnlyForm}
                    />
                  </Grid>

                  {/* Who am I */}
                  <Grid item xs={12}>
                    <TextField
                      sx={{
                        "& .MuiOutlinedInput-root": { borderRadius: "15px" },
                      }}
                      label={language.sa_whoAmI}
                      name="whoAmI"
                      value={sa.whoAmI}
                      onChange={saOnChange}
                      multiline
                      minRows={4}
                      fullWidth
                      disabled={readOnlyForm}
                    />
                  </Grid>

                  {/* Document upload */}
                  <Grid item xs={12} md={6}>
                    <Button
                      variant="outlined"
                      component="label"
                      startIcon={<AttachFile />}
                      sx={{
                        textTransform: "none",
                        color: "#dc2626",
                        borderColor: "#b91c1c",
                        borderWidth: 1,
                        borderRadius: "0.7rem",
                        fontWeight: 545,
                        fontSize: "0.97rem",
                        "&:hover": { borderColor: "#b91c1c", color: "#b91c1c" },
                      }}
                      disabled={readOnlyForm}
                    >
                      {sa.documentName
                        ? language.sa_changeDoc
                        : language.sa_uploadDoc + " *"}
                      <input
                        hidden
                        type="file"
                        name="document"
                        accept=".pdf"
                        onChange={(e) => {

                          const file = e.target.files?.[0];
                          if (!file) return;
                          const reader = new FileReader();
                          reader.onload = () => {
                            const result = reader.result;
                            const base64 =
                              typeof result === "string"
                                ? result.split(",")[1] || ""
                                : "";
                            setSa((s) => ({
                              ...s,
                              documentName: file.name,
                              documentBase64: base64,
                            }));
                          };
                          reader.readAsDataURL(file);
                        }}
                      />
                    </Button>
                    {getDocumentError() && (
                      <Typography color="error" variant="caption" display="block" sx={{ mt: 2 }} >
                        {getDocumentError()}
                      </Typography>
                    )}
                    <Typography
                      variant="caption"
                      display="block"
                      sx={{ mt: 1, color: "text.secondary" }}
                    >
                      {language.sa_files}
                    </Typography>
                    {sa.documentName && (
                      <Typography variant="body2" sx={{ mt: 0.5 }}>
                        {language.sa_choosed}: {sa.documentName}
                      </Typography>
                    )}
                  </Grid>
                </Grid>
              </>
            )}
          </Paper>

          {/* Submit */}
          {showForm && (
            <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
              <Button
                type="submit"
                variant="contained"
                size="large"
                sx={{
                  textTransform: "none",
                  borderWidth: 2,
                  borderRadius: "1.5rem",
                  padding: "0.5rem 1.4rem",
                  borderColor: "#e5e7eb",
                  color: "#fff",
                  fontWeight: "bold",
                  backgroundColor: "#dc2626",
                  "&:hover": {
                    backgroundColor: "#dc2626",
                    borderColor: "#b91c1c",
                  },
                }}
                disabled={readOnlyForm || submitting}
              >
                {language.submit}
              </Button>
            </Box>
          )}
        </Box>
        <Snackbar
          open={snackbar.open}
          autoHideDuration={6000}
          onClose={closeSnackbar}
          anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        >
          <Alert
            onClose={closeSnackbar}
            severity={snackbar.severity}
            sx={{ width: "100%" }}
          >
            {snackbar.message}
          </Alert>
        </Snackbar>
      </section>
    );
};

export default withAuthChecker(withLanguage(StudentApplication, "SubjectDeclaration"), 5);
